module.exports = __webpack_public_path__ + "static/img/logo_completo.74e626c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_completo.png
// module id = 52uR
// module chunks = 1